import { AccountEntry } from 'api/accountEntries/accountEntries.types';
import { JobStatus } from './types';

export const isAllocationJobBilledOrCancelled = (allocation: AccountEntry) => (
    allocation.job.status === JobStatus.BILLED ||
    allocation.job.status === JobStatus.CANCELLED
  );
